import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const PopupContent = {
    image: "./images/consultation/community.jpg",
    popupLink: [
        "https://www.youtube.com/embed/3L7NRUUHCoQ?autoplay=1&mute=1", // Embed + Autoplay + Muted
    ],
};

function CommunityVideo() {
    const [toggler, setToggler] = useState(false);

    return (
        <div className="row row--15 m-0">
            <div className="col-12 p-0">
                <div className="video-popup icon-center w-100">
                    <div className="thumbnail w-100">
                        <img className="radius-small w-100" src={PopupContent.image} alt="Video Thumbnail" />
                    </div>
                    <div className="video-icon">
                        <button className="btn-default rounded-player" onClick={() => setToggler(!toggler)}>
                            <span><FiPlay /></span>
                        </button>
                    </div>
                    <FsLightbox
                        toggler={toggler}
                        sources={PopupContent.popupLink}
                    />
                </div>
            </div>
        </div>
    );
}

export default CommunityVideo;
